






























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Toast } from "vant";
import axios from "axios";
import detailCom from "@/components/estate/detailCom.vue";
const estateModule = namespace("estate");

@Component({
  components: { detailCom }
})
export default class Info extends Vue {
  @estateModule.State("estateDetail") estateDetail!: any;
  show: boolean = false;
  mounted() {
    this.getEstateDetail();
  }
  /**获取详情 */
  async getEstateDetail() {
    const { success } = await this.$store.dispatch("estate/getEstateDetail", {
      id: this.$route.query.id
    });
  }
  /*商户端 催办、返回 */
  handleCreateClick(type: number) {
    if (type == 1) {
      this.estateMaintainUrge();
    } else {
      this.$router.push({
        path: "/estate"
      });
    }
  }
  /**催办 */
  async estateMaintainUrge() {
    const { error, success } = await this.$store.dispatch(
      "estate/estateMaintainUrge",
      {
        id: this.$route.query.id
      }
    );
    if (success) {
      this.show = true;
    }
    if (error) {
      Toast(error.msg);
    }
  }
  handelBtn() {
    this.show = false;
    this.getEstateDetail();
  }
}
